// src/utils/pushEligibleTypes.ts — Whitelist push téléphone (CHANTIER-PUSH-NOTIFICATIONS-PWA.md)

import type { NotificationType } from '../types/notifications';
import { appendBusinessIdToPath } from './notificationDeepLink';

/** Types éligibles au push OS. Tout le reste = in-app uniquement. */
export const PUSH_ELIGIBLE_TYPES: readonly NotificationType[] = [
  'appointment_request',
  'pickup_request',
  'appointment_reminder_2h',
  'out_of_stock',
  'low_stock',
  'payment_plan_reminder_due',
  'payment_plan_overdue',
  'support_ticket_reply',
  'support_ticket_opened_for_you',
  'activity_report_submit_reminder',
  'activity_report_validated',
  'activity_report_overdue',
  'licence_payment_due_7d',
  'licence_payment_due_1d',
  'licence_payment_blocked',
  'manufacturing_order_on_hold',
  'manufacturing_order_done',
  'inventory_audit_started',
  'inventory_audit_to_close',
  'performance_sheets_generated',
  'performance_sheet_validated',
] as const;

const PUSH_ELIGIBLE_SET = new Set<string>(PUSH_ELIGIBLE_TYPES);

export function isPushEligibleType(type: string | undefined | null): boolean {
  if (!type) return false;
  return PUSH_ELIGIBLE_SET.has(type);
}

/** Deep-link relatif pour ouverture au clic sur la notif push (avec businessId). */
export function getPushNotificationDeepLink(data: {
  type?: string;
  supportTicketId?: string;
  productId?: string;
  businessId?: string;
}): string {
  let path: string;
  switch (data.type) {
    case 'appointment_request':
      path = '/appointment-requests';
      break;
    case 'appointment_reminder_2h':
      path = '/appointments';
      break;
    case 'pickup_request':
      path = '/pickups';
      break;
    case 'out_of_stock':
    case 'low_stock':
      path = data.productId
        ? `/inventory/products?highlight=${encodeURIComponent(data.productId)}`
        : '/inventory/products';
      break;
    case 'payment_plan_reminder_due':
    case 'payment_plan_overdue':
      path = '/payment-plans';
      break;
    case 'licence_payment_due_7d':
    case 'licence_payment_due_1d':
    case 'licence_payment_blocked':
      path = '/mon-paiement';
      break;
    case 'messages_clients_ready':
    case 'messages_clients_no_phone':
      path = '/messages-clients';
      break;
    case 'manufacturing_order_on_hold':
    case 'manufacturing_order_done':
      path = '/manufacturing/orders';
      break;
    case 'inventory_audit_started':
    case 'inventory_audit_to_close':
      path = '/inventory/audit';
      break;
    case 'inventory_loss_created':
      path = '/inventory/losses';
      break;
    case 'support_ticket_reply':
    case 'support_ticket_opened_for_you':
      path = data.supportTicketId
        ? `/aide?open=${encodeURIComponent(data.supportTicketId)}`
        : '/aide';
      break;
    case 'activity_report_submit_reminder':
    case 'activity_report_validated':
    case 'activity_report_overdue':
      path = '/activity/reports';
      break;
    case 'performance_sheets_generated':
    case 'performance_sheet_validated':
      path = '/performance-indicators';
      break;
    default:
      path = '/dashboard';
  }
  return appendBusinessIdToPath(path, data.businessId);
}
